// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.div-table {
    display: table;
    width: 100%;
    border-spacing: 5px; /* cellspacing:poor IE support for  this */
}

.div-table-row {
    display: table-row;
    width: auto;
    clear: both;
}

.div-table-col {
    float: left;
    display: table-column;
    min-width: 200px;
    max-width: 100%;
}

.TypeIcon {
    align-self: center;
    margin-right: 5px;
    color: black;
}

    .TypeIcon .mat-icon:hover {
        color: black;
    }
    .expanded{
        transform:rotate(90deg);
    }

.expando {
    transition: all;
    transition-duration: 0.2s;
    align-self: center;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/treetable/treetableitem.control.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB,EAAE,0CAA0C;AACnE;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;IAEI;QACI,YAAY;IAChB;IACA;QACI,uBAAuB;IAC3B;;AAEJ;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".div-table {\n    display: table;\n    width: 100%;\n    border-spacing: 5px; /* cellspacing:poor IE support for  this */\n}\n\n.div-table-row {\n    display: table-row;\n    width: auto;\n    clear: both;\n}\n\n.div-table-col {\n    float: left;\n    display: table-column;\n    min-width: 200px;\n    max-width: 100%;\n}\n\n.TypeIcon {\n    align-self: center;\n    margin-right: 5px;\n    color: black;\n}\n\n    .TypeIcon .mat-icon:hover {\n        color: black;\n    }\n    .expanded{\n        transform:rotate(90deg);\n    }\n\n.expando {\n    transition: all;\n    transition-duration: 0.2s;\n    align-self: center;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
